var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountBadgeEntityName } from '../../../../../backend/features/badges/shared';
import { AccountBadgeSlideoutTopBarMenu } from '../../../../../ui/features/badge-management/components/AccountBadgeSlideout/AccountBadgeSlideoutTopBarMenu';
import { useAccountBadgeActions } from '../../../../../ui/features/badge-management/hooks/useAccountBadgeActions';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { ModalSlideout, ModalSlideoutHeader, useModalSlideoutScroll, } from '@juvare/common-web-ui/ModalSlideout';
import { PartialError } from '@juvare/common-web-ui/PartialError';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { AccountBadgeSlideoutBottomActions } from './AccountBadgeSlideoutBottomActions';
import { AccountBadgeSlideoutContent } from './AccountBadgeSlideoutContent';
import { AccountBadgeSlideoutHeader } from './AccountBadgeSlideoutHeader';
export const AccountBadgeSlideout = ({ accountBadgeId, onClose, refetchAccountBadgeList, getAccountBadgeSlideoutDataElements, onAccountBadgeAccountDetailsEdit, renderCustomTopActions, renderCustomTopMenuActions, renderCustomBottomActions, disableStatusLabelActions, }) => {
    const { handleScroll, handleResetScroll } = useModalSlideoutScroll();
    const handleClose = (changed) => {
        handleResetScroll();
        onClose(changed);
    };
    const { data: accountBadge, isLoading: isAccountBadgeLoading, error: accountBadgeError, mutate: refetchAccountBadge, } = useStorageGet(accountBadgeEntityName, accountBadgeId);
    const handleRefetch = () => __awaiter(void 0, void 0, void 0, function* () {
        refetchAccountBadgeList();
        if (!!accountBadgeId) {
            yield refetchAccountBadge();
        }
    });
    const accountBadgeActions = useAccountBadgeActions({
        accountBadge,
        onActionSuccess: handleRefetch,
    });
    const topBarMenuItems = useTopBarMenuItems(accountBadge, accountBadgeActions, renderCustomTopMenuActions);
    return (React.createElement(ModalSlideout, { open: !!accountBadgeId, onClose: () => handleClose(false), sx: { width: { xs: '100%', sm: 600 } } }, isAccountBadgeLoading ? (React.createElement(Box, { sx: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        } },
        React.createElement(CircularProgress, null))) : Boolean(accountBadgeError) ? (React.createElement(PartialError, { error: accountBadgeError })) : !accountBadge ? (React.createElement(React.Fragment, null,
        React.createElement(AccountBadgeSlideoutTopBarMenu, { menuItems: [], onClose: onClose }),
        React.createElement(ModalSlideoutHeader, { sx: { paddingTop: 7 } }))) : (React.createElement(React.Fragment, null,
        React.createElement(AccountBadgeSlideoutTopBarMenu, { menuItems: topBarMenuItems, onClose: onClose }),
        React.createElement(AccountBadgeSlideoutHeader, { accountBadge: accountBadge, accountBadgeActions: accountBadgeActions, renderCustomTopActions: renderCustomTopActions }),
        React.createElement(AccountBadgeSlideoutContent, { accountBadge: accountBadge, accountBadgeActions: accountBadgeActions, onScroll: handleScroll, getAccountBadgeSlideoutDataElements: getAccountBadgeSlideoutDataElements, onAccountBadgeAccountDetailsEdit: onAccountBadgeAccountDetailsEdit, disableStatusLabelActions: disableStatusLabelActions }),
        React.createElement(AccountBadgeSlideoutBottomActions, { accountBadge: accountBadge, accountBadgeActions: accountBadgeActions, onRefetch: handleRefetch, onClose: handleClose, renderCustomBottomActions: renderCustomBottomActions })))));
};
function useTopBarMenuItems(accountBadge, accountBadgeActions, renderCustomTopMenuActions) {
    const { t } = useBadgingTranslation();
    if (!accountBadge) {
        return [];
    }
    if (renderCustomTopMenuActions) {
        return renderCustomTopMenuActions({ accountBadge, actions: accountBadgeActions });
    }
    return [
        ...(accountBadgeActions.canEditDistributionStatus
            ? [
                {
                    label: t('badges.badgeDetails.accountBadgeTable.menuItems.changeDistributionStatus.menuItemLabel'),
                    onClick: accountBadgeActions.handleAccountBadgeDistributionStatusEdit,
                },
            ]
            : []),
        ...(accountBadgeActions.canEditExpirationDate
            ? [
                {
                    label: t('badges.badgeDetails.accountBadgeTable.menuItems.changeExpirationDate.menuItemLabel'),
                    onClick: accountBadgeActions.handleAccountBadgeExpirationDateEdit,
                },
            ]
            : []),
        {
            label: t('badges.badgeDetails.accountBadgeTable.menuItems.history.menuItemLabel'),
            onClick: accountBadgeActions.handleAccountBadgeHistoryOpen,
        },
    ];
}
